export default function EFAddCircle(props: any) {
    return (
        <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="CSR社会貢献" transform="translate(-1144.000000, -3752.000000)">
                    <g id="编组-30" transform="translate(816.000000, 3307.000000)">
                        <g id="+备份" transform="translate(328.000000, 445.000000)">
                            <rect id="矩形" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="28" height="28"></rect>
                            <path
                                d="M14,0 C21.7319865,0 28,6.2680135 28,14 C28,21.7319865 21.7319865,28 14,28 C6.2680135,28 0,21.7319865 0,14 C0,6.2680135 6.2680135,0 14,0 Z M14,1.7 C7.20689758,1.7 1.7,7.20689758 1.7,14 C1.7,20.7931024 7.20689758,26.3 14,26.3 C20.7931024,26.3 26.3,20.7931024 26.3,14 C26.3,7.20689758 20.7931024,1.7 14,1.7 Z M14.8,8 L14.8,13.2 L20,13.2 L20,14.8 L14.8,14.799 L14.8,20 L13.2,20 L13.2,14.799 L8,14.8 L8,13.2 L13.2,13.2 L13.2,8 L14.8,8 Z"
                                id="形状结合"
                                fill="#000000"
                                fillRule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
